import { combineReducers } from 'redux-immutable'
import departmentCreateReducer from './department-create-reducer'
import departmentListReducer from './department-list-reducer'
import departmentEditReducer from './department-edit-reducer'
import departmentGetReducer from './department-get-reducer'
import departmentDeactivateReducer from './department-deactivate-reducer'
import departmentExportReducer from './department-export-reducer'

export default combineReducers({
  departmentCreate: departmentCreateReducer,
  departmentList: departmentListReducer,
  departmentEdit: departmentEditReducer,
  departmentGet: departmentGetReducer,
  departmentDeactivate: departmentDeactivateReducer,
  departmentExport: departmentExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/department/index.js